import React, { useState } from 'react';

interface WelcomeTrialModalProps {
  onStart: () => Promise<void>; // calls /billing/start-trial and refreshes app state
  onDone: () => void; // called after successful trial start, closes modal
}

export default function WelcomeTrialModal({ onStart, onDone }: WelcomeTrialModalProps) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleStart = async () => {
    setLoading(true);
    try {
      await onStart();
      setDone(true);
      setTimeout(onDone, 1400); // auto-close after showing success
    } catch (e) {
      setLoading(false);
      alert('Could not start trial. Please try again.');
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 10000,
      background: 'rgba(15,23,42,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff', borderRadius: 24, width: '100%', maxWidth: 420,
        padding: '40px 32px 32px', textAlign: 'center',
        boxShadow: '0 24px 80px rgba(0,0,0,0.25)',
        fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}>
        {!done ? (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🎉</div>
            <h2 style={{ fontSize: 22, fontWeight: 900, color: '#0f172a', margin: '0 0 10px' }}>
              Welcome to CloudAIRambo!
            </h2>
            <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, margin: '0 0 28px' }}>
              Start your <strong>7-day free trial</strong> — full access to every
              module (Ledger, POS, Staff, Queue, Gym, Canteen &amp; Ultra Suite).
              <br /><br />
              <strong>No credit card needed.</strong>
            </p>
            <button
              onClick={handleStart}
              disabled={loading}
              style={{
                width: '100%', padding: '14px', borderRadius: 14, border: 'none',
                background: loading ? '#a5b4fc' : 'linear-gradient(135deg,#6366f1,#7c3aed)',
                color: '#fff', fontWeight: 800, fontSize: 15,
                cursor: loading ? 'default' : 'pointer',
              }}
            >
              {loading ? 'Starting your trial…' : '🎁 Start Free 7-Day Trial'}
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ fontSize: 20, fontWeight: 900, color: '#16a34a', margin: '0 0 8px' }}>
              You're all set!
            </h2>
            <p style={{ fontSize: 13, color: '#64748b' }}>
              Your 7-day trial is active. Enjoy full access!
            </p>
          </>
        )}
      </div>
    </div>
  );
}
